import {$, ID, Model, ResponseFill, ResponseSerialize} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'

export default class AssociarCargaMotoristaRequest extends Model {
  readonly $name: string = 'AssociarCargaMotoristaRequest'

  @ResponseFill()
  cargas: Carga[] = []

  async associarCargaMotorista(spinner = 'associarCargaMotorista') {
    const fetch = async () => {
      return await this.POST('/user/carga/motorista/associacao/lote', this)
    }

    return await $.await.run(fetch, spinner)
  }
}
